module.exports = __webpack_public_path__ + "static/media/entrepreneurial-platform-ad2.87ce5f63.png";